import React from "react";

const PPCIcon = () => {
  return (
    <svg
      width="102"
      height="102"
      viewBox="0 0 102 102"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_d_317_1365)">
        <rect
          x="8"
          y="4"
          width="86"
          height="86"
          rx="16"
          fill="#FFA8A8"
          shape-rendering="crispEdges"
        />
        <g clip-path="url(#clip0_317_1365)">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M54.9988 22.9955H29.0046C28.4747 22.9955 27.9663 23.2061 27.5913 23.5813C27.2163 23.9564 27.0055 24.4654 27.0055 24.9962V69.0039C27.0055 69.5348 27.2163 70.0438 27.5913 70.4189C27.9663 70.794 28.4747 71.0046 29.0046 71.0046H72.9951C73.5251 71.0046 74.0335 70.794 74.4085 70.4189C74.7835 70.0438 74.9943 69.5348 74.9943 69.0039V42.999H58.9984C57.9374 42.999 56.92 42.5774 56.17 41.8271C55.42 41.0768 54.9988 40.0594 54.9988 38.9987V22.9955ZM58.9988 25.8255L72.1672 38.999H58.9989L58.9988 38.9987V25.8255ZM78.9943 41.0322V69.0039C78.9943 70.5952 78.3624 72.1214 77.2374 73.2468C76.1124 74.3722 74.5865 75.0046 72.9951 75.0046H29.0046C27.4133 75.0046 25.8873 74.3722 24.7623 73.2468C23.6374 72.1214 23.0055 70.5952 23.0055 69.0039V24.9962C23.0055 23.405 23.6374 21.8788 24.7623 20.7534C25.8873 19.6279 27.4133 18.9955 29.0046 18.9955H56.983C57.5089 18.9915 58.0269 19.1951 58.4133 19.5816L78.409 39.5851C78.7994 39.9757 79.003 40.5006 78.9943 41.0322ZM43.0022 30.9973C43.0022 29.8927 42.1068 28.9973 41.0022 28.9973C39.8977 28.9973 39.0022 29.8927 39.0022 30.9973V35.033C38.8301 35.0422 38.6594 35.0537 38.4911 35.0684C37.6718 35.1397 36.7643 35.2933 35.9208 35.6821C35.0308 36.0925 34.2448 36.7509 33.7133 37.7376C33.2033 38.6843 33.0035 39.7919 33.0035 40.999C33.0035 43.2892 34.1931 44.9276 35.5975 46.0984C36.9025 47.1863 38.5784 48.0242 39.9989 48.7345L40.1075 48.7888C41.6639 49.5673 42.9346 50.2147 43.8457 50.9742C44.6909 51.6788 45.0009 52.2908 45.0009 53.0011C45.0009 53.7944 44.8658 54.187 44.7696 54.3655C44.695 54.5041 44.6037 54.5957 44.409 54.6855C44.1677 54.7967 43.783 54.8932 43.1664 54.9469C42.5516 55.0004 41.8536 55.0018 41.0022 55.0018C39.4819 55.0018 38.3961 54.7622 37.7567 54.3938C37.272 54.1145 37.0035 53.764 37.0035 53.0011C37.0035 51.8966 36.1081 51.0011 35.0035 51.0011C33.899 51.0011 33.0035 51.8966 33.0035 53.0011C33.0035 55.2388 34.0748 56.8887 35.7596 57.8596C36.7289 58.4181 37.8519 58.7274 39.0022 58.8791V63.0029C39.0022 64.1075 39.8977 65.0029 41.0022 65.0029C42.1068 65.0029 43.0022 64.1075 43.0022 63.0029V58.9672C43.1744 58.958 43.3451 58.9464 43.5133 58.9318C44.3326 58.8605 45.2401 58.7069 46.0837 58.318C46.9737 57.9077 47.7597 57.2492 48.2912 56.2625C48.8012 55.3158 49.0009 54.2083 49.0009 53.0011C49.0009 50.711 47.8114 49.0726 46.407 47.9018C45.102 46.8139 43.4261 45.9759 42.0056 45.2657L42.0056 45.2657L41.897 45.2114C40.3406 44.4329 39.0699 43.7855 38.1588 43.026C37.3136 42.3214 37.0035 41.7094 37.0035 40.999C37.0035 40.2058 37.1387 39.8131 37.2348 39.6346C37.3095 39.4961 37.4008 39.4045 37.5955 39.3147C37.8367 39.2035 38.2215 39.107 38.8381 39.0533C39.4529 38.9998 40.1509 38.9983 41.0022 38.9983C42.3877 38.9983 43.488 39.3203 44.1728 39.756C44.8163 40.1654 45.0009 40.5895 45.0009 40.999C45.0009 42.1036 45.8964 42.999 47.0009 42.999C48.1055 42.999 49.0009 42.1036 49.0009 40.999C49.0009 38.9282 47.8459 37.3519 46.3199 36.3811C45.3544 35.7669 44.2137 35.3668 43.0022 35.162V30.9973ZM56.9988 55.0018C55.8942 55.0018 54.9988 55.8973 54.9988 57.0018C54.9988 58.1064 55.8942 59.0018 56.9988 59.0018H68.9962C70.1008 59.0018 70.9962 58.1064 70.9962 57.0018C70.9962 55.8973 70.1008 55.0018 68.9962 55.0018H56.9988Z"
            fill="white"
          />
        </g>
      </g>
      <defs>
        <filter
          id="filter0_d_317_1365"
          x="0"
          y="0"
          width="102"
          height="102"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="4" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_317_1365"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_317_1365"
            result="shape"
          />
        </filter>
        <clipPath id="clip0_317_1365">
          <rect
            width="56"
            height="56"
            fill="white"
            transform="translate(23 19)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default PPCIcon;
